<script>
import { EventBus, Topics, Types } from '@/event-bus'
import { getLastMonths } from '@/utils/dateutils'
import http from '@/utils/http'

export default {
  name: 'EtaDownloadRelatorio',
  props: {
    eta: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    dataReferencia: new Date(),
    mesesPesquisa: getLastMonths(12),
    data: getLastMonths(1)[0],
    downloadTemplateLoading: false,
  }),
  beforeMount() {},
  methods: {
    async download() {
      this.downloadTemplateLoading = true

      await http.eta
        .getDownload(`eta/${this.eta.id}/report/download`, {
          mesReferencia: this.data,
        })
        .then((e) => {
          const blob = e.data
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${this.eta.nome}-${this.data.replace('/', '-')}.docx`
          link.click()
        })
        .catch(() => {
          EventBus.$emit(Topics.NOTIFICATIONS, {
            message: 'Erro ao baixar o relatório',
            type: Types.DANGER,
          })
        })
        .finally(() => {
          this.downloadTemplateLoading = false
        })
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-8">
        <h1>Exportar Relatório</h1>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button @click="$emit('close')">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>

    <p>
      Por favor, note que o tempo de download pode variar dependendo do tamanho
      do relatório e da velocidade da sua conexão com a internet.
    </p>

    <md-field style="width: 50%">
      <label for="data">Mês de referência</label>
      <md-select id="data" v-model="data" name="data">
        <md-option v-for="i in mesesPesquisa" :key="i" :value="i">
          {{ i }}
        </md-option>
      </md-select>
    </md-field>

    <md-button class="md-primary md-raised" @click="() => download()">
      <md-icon>file_download</md-icon>
      Gerar Relatório
    </md-button>

    <md-progress-spinner
      v-if="downloadTemplateLoading"
      :md-diameter="40"
      :md-stroke="5"
      md-mode="indeterminate"
    />
  </div>
</template>

<style scoped lang="scss"></style>
